module.exports = __webpack_public_path__ + "img/Teamtip_Logo_300x300.b385c016.png";